import { Button, Form, Input } from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { useMemo } from "react";

const ContactForm = () => {
  const breakpoints = useBreakpoint()

	const colSpan: {offset: number; span: number;} = useMemo(() => {
		const screens = Object.entries(breakpoints).filter(screen => !!screen[1])
		const screen_size = screens[screens.length - 1]?.[0]
		switch (screen_size) {
			case 'xl': return {offset: (24 / 3), span: (24 / 3)}
			case 'lg': return {offset: (24 / 3), span: (24 / 2)}
			case 'md': return {offset: (24 / 3), span: (24 / 2)}
			case 'sm': return {offset: (24 / 4), span: (24 / 2)}
			case 'xs': return {offset: (24 / 3), span: (24 / 2)}
			default: return {offset: (24 / 3), span: (24 / 3)}
		}
	}, [breakpoints])


  const onFinish = (values: any) => {
    const email = 'zohaib_phone@outlook.com'
    const {name, subject, message} = values;
    const body = `From: ${name} %0D%0A%0D%0A${message}`
    window.open(`mailto:${email}?subject=${subject}&body=${body}`)
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Form
      name="basic"
      labelCol={{ span: colSpan.offset }}
      wrapperCol={{ span: colSpan.span }}
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      <Form.Item
        label="Name"
        name="name"
        rules={[{ required: true, message: "Please input your Name!" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Subject"
        name="subject"
        rules={[{ required: true, message: "Please input Subject!" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Message"
        name="message"
        rules={[{ required: true, message: "Please write your Message!" }]}
      >
        <Input.TextArea autoSize={{minRows: 2, maxRows: 6}} showCount={true} />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: colSpan.offset, span: colSpan.span }}>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ContactForm;
